export enum Metric {
    VIEW = 'view',
    VIEWS = 'views',
    CLICK = 'click',
    CLICKS = 'clicks'
}
